import styled from 'styled-components'
import { colorTheme } from '../../../style/theme/colorTheme'

export const WaiterCallStatusWrap = styled.div`
	font-size: 1rem;
	display: flex;
	padding: 0 1.25em;
	align-items: center;
	cursor: pointer;

	> svg {
		width: 2.5em;
		height: 1.72em;
		flex-shrink: 0;
		fill: ${colorTheme.restaurant.waiterCall.areas.waiter.icon};
	}
`
WaiterCallStatusWrap.displayName = 'WaiterCallStatusWrap'
